import { AvailabilitiesState } from "~/store/availabilities/availabilities.types"

const state = ():AvailabilitiesState => ({
  data: {},
  filters: {}
})

export default state
